/*
 * @Author: fz
 * @Date: 2021-10-15 11:21:17
 * @LastEditTime: 2023-10-26 10:24:26
 * @LastEditors: qqw qinqianwen@e6yun.com
 * @Description: In User Settings Edit
 */
import http from "e6-base-core/axios/config";

import { e6ModuleBaseDataApi } from "@/config/api";
const { host, E6_MS_TMS_REPORT_WEB } = e6ModuleBaseDataApi;
// e6yun
//获取调用表格数据
export function getInterfaceLogList(data) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/dockInterfaceLog/findByPage`,
    method: "post",
    data
  });
}

export function retry(data) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/dockInterfaceLog/retry`,
    method: "post",
    data
  });
}

//获取接口名称
export function getInterfaceDropBox() {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/dockInterfaceLog/interfaceDropBox`,
    method: "get"
  });
}

// 接口类型下拉
export function getInterfaceTypeDropBox() {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/dockInterfaceLog/interfaceTypeDropBox`,
    method: "get"
  });
}

// 接口日志获取调用详情
export function getInterfaceDetail(data) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/dockInterfaceLog/logParameter`,
    method: "post",
    data
  });
}

//导出推送数据
export function exportOutSideInterfaceLogList(data) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/customerInterfaceLog/export`,
    method: "post",
    responseType: "blob",
    headers: { "Content-Type": "application/json" },
    data
  });
}
